import { makeAbsenceWarningRepository } from 'shared/infra/repositories';

import ConfirmAbsenceWarningUseCase from './implementations/ConfirmAbsenceWarningUseCase';

let instance: ConfirmAbsenceWarningUseCase | null = null;

export default function makeConfirmAbsenceWarningUseCase() {
  if (!instance) {
    const absenceWarningRepository = makeAbsenceWarningRepository();

    instance = new ConfirmAbsenceWarningUseCase(absenceWarningRepository);
  }

  return instance;
}
